<template>
  <div class="oder_management">
    <div ref="tablePanel" class="fullheight">
      <div class="table_content">
        <el-tabs @tab-click="handleClick" v-model="tabsVal">
          <el-tab-pane :label="item.label" :name="item.name" v-for="item in tabList" :key="item.index"></el-tab-pane>
        </el-tabs>
        <div class="top_search">
          <el-row style="height: 100%; width: 100%">
            <el-col :span="11" class="col_style button_group">
              <el-button type="primary" @click="insertOrder()">新增订单</el-button>
              <el-button @click="showInvoiceApply()">发票申请</el-button>
            </el-col>
            <el-col :span="6" class="col_style">
              <p>订单日期：</p>
              <el-date-picker
                value-format="yyyy-MM-dd HH:mm:ss"
                v-model="dateRangeVal"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="loadData"
              >
              </el-date-picker>
            </el-col>
            <el-col :span="6" :offset="1" class="col_style">
              <el-input
                v-if="tenantId == '-1'"
                v-model="code"
                @change="loadData"
                :clearable="true"
                placeholder="请输入订单编号,客户名称搜索"
                suffix-icon="el-icon-search"
                @keyup.enter.native="loadData"
              >
                <!-- <el-button slot="append" type="primary" @click="loadData">搜索</el-button> -->
              </el-input>
              <el-input
                v-else
                v-model="code"
                @change="loadData"
                :clearable="true"
                placeholder="请输入订单编号搜索"
                suffix-icon="el-icon-search"
                @keyup.enter.native="loadData"
              >
                <!-- <el-button slot="append" type="primary" @click="loadData">搜索</el-button> -->
              </el-input>
            </el-col>
          </el-row>
        </div>

        <el-table
          ref="ecoTable"
          :style="{
            height: `${tableMaxHeight}` + 'px'
          }"
          :max-height="tableMaxHeight"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          border
          :header-cell-style="headerCellStyle"
          :cell-style="cellStyle"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column type="index" label="序号" width="55"> </el-table-column>
          <el-table-column prop="order_no" label="订单编号" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-link type="primary" :underline="false" @click="orderRecord(scope.row.id)">{{ scope.row.order_no }}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="order_time" label="订单日期" :formatter="dateFormatter" show-overflow-tooltip> </el-table-column>
          <el-table-column prop="customer_name" label="客户名称" show-overflow-tooltip></el-table-column>
          <el-table-column prop="account_name" label="产品名称" show-overflow-tooltip></el-table-column>
          <el-table-column prop="order_amount" label="订单金额" :formatter="numberFormatter"> </el-table-column>
          <el-table-column prop="order_status" label="订单状态" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.order_status == 0" style="color: #ababab">已关闭</span>
              <span v-if="scope.row.order_status == 1" style="color: #ff4f4f">待确认</span>
              <span v-if="scope.row.order_status == 2" style="color: #ff982a">待付款</span>
              <span v-if="scope.row.order_status == 3" style="color: #53a942">已付款</span>
              <span v-if="scope.row.order_status == 4" style="color: #53a942">付款已确认</span>
              <span v-if="scope.row.order_status == 5" style="color: #a25925">待开票</span>
              <span v-if="scope.row.order_status == 6" style="color: #3894ff">已开票</span>
            </template>
          </el-table-column>
          <el-table-column prop="payment_no" label="付款单号" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-link type="primary" :underline="false" @click="paymentRecord(scope.row.payment_id, scope.row.order_status)">{{
                scope.row.payment_no
              }}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="payment_time" label="付款单日期" show-overflow-tooltip> </el-table-column>
          <el-table-column prop="payment_amount" label="付款单金额" :formatter="numberFormatter" show-overflow-tooltip> </el-table-column>
          <el-table-column prop="pay_amount" label="实际收款" :formatter="numberFormatter" show-overflow-tooltip> </el-table-column>
          <el-table-column prop="name" label="操作">
            <template slot-scope="scope">
              <el-dropdown @command="handleCommand" v-if="scope.row.order_status == '1' || scope.row.order_status == '2' || scope.row.order_status == '3'">
                <el-link type="primary" :underline="false"> 管理<i class="el-icon-arrow-down el-icon--right"></i> </el-link>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-if="scope.row.order_status == '1'" :command="{ row: scope.row, command: 'edit' }">编辑订单</el-dropdown-item>
                  <el-dropdown-item v-if="tenantId != '-1' && scope.row.order_status == '1'" :command="{ row: scope.row, command: 'close' }"
                    >关闭订单</el-dropdown-item
                  >
                  <el-dropdown-item
                    v-if="tenantId == '-1' && (scope.row.order_status == '1' || scope.row.order_status == '2')"
                    :command="{ row: scope.row, command: 'close' }"
                    >关闭订单</el-dropdown-item
                  >
                  <el-dropdown-item v-if="tenantId == '-1' && scope.row.order_status == '1'" :command="{ row: scope.row, command: 'confirm' }"
                    >订单确认</el-dropdown-item
                  >
                  <el-dropdown-item v-if="scope.row.order_status == '2'" :command="{ row: scope.row, command: 'pay' }">付款</el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.order_status == '3'" :command="{ row: scope.row, command: 'editPay' }">编辑付款</el-dropdown-item>
                  <el-dropdown-item v-if="tenantId == '-1' && scope.row.order_status == '3'" :command="{ row: scope.row, command: 'confirmPay' }"
                    >确认收款</el-dropdown-item
                  >
                  <el-dropdown-item v-if="scope.row.order_status == '3'" :command="{ row: scope.row, command: 'closePay' }">取消付款</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <div class="page_bean">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 40, 50, 100, 500]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
      <!-- 新增订单 -->
      <insert-order :show="showInsert" :tenantId="tenantId" :orderId="orderId" :isEdit="isEdit" @closeInsert="closeInsert"></insert-order>
      <!-- 订单详情 -->
      <order-record :show="showOrderRecord" :orderId="orderId" @closeOrderRecord="closeOrderRecord"> </order-record>
      <!-- 订单确认 -->
      <insert-order-confirm :show="showOrderConfirm" :orderId="orderId" @closeConfirm="closeConfirm"> </insert-order-confirm>
      <!-- 订单付款 -->
      <insert-payment
        :show="showPayment"
        :orderId="orderId"
        :paymentId="paymentId"
        :isEdit="isEdit"
        @closePayment="closePayment"
        @showOrderDetail="showOrderDetail"
      >
      </insert-payment>
      <!-- 付款确认 -->
      <payment-confirm :show="showPaymentConfirm" :paymentId="paymentId" @closePaymentConfirm="closePaymentConfirm"> </payment-confirm>
      <!-- 付款记录 -->
      <payment-record :show="showPaymentRecord" :paymentId="paymentId" :isCancle="isCancle" @closePaymentRecord="closePaymentRecord"> </payment-record>
      <!-- 开票 -->
      <invoice-record-detail-order :show="showInvoice" :data="invoiceData" :selectData="multipleSelection" @closeDetailDialog="closeInvoice" />
    </div>
  </div>
</template>

<script>
import OrderRecord from './billingCenter/orderRecord.vue'
import InsertOrder from './billingCenter/insertOrder.vue'
import InsertOrderConfirm from './billingCenter/insertOrderConfirm.vue'
import InsertPayment from './billingCenter/insertPayment.vue'
import PaymentRecord from './billingCenter/paymentRecord.vue'
import PaymentConfirm from './billingCenter/paymentConfirm.vue'
import InvoiceRecordDetailOrder from './invoiceRecord/invoiceRecordDetailOrder.vue'
import utils from '@/utils.js'
export default {
  components: {
    InsertOrder,
    InsertOrderConfirm,
    InvoiceRecordDetailOrder,
    InsertPayment,
    PaymentConfirm,
    OrderRecord,
    PaymentRecord
  },
  data() {
    return {
      showInsert: false,
      showOrderRecord: false,
      showOrderConfirm1: false,
      showOrderConfirm: false,
      showPayment: false,
      showPaymentConfirm: false,
      showPaymentRecord: false,
      isCancle: false,
      tenantId: '-1',
      dateRangeVal: '',
      code: '',
      tabsVal: 'total',
      tableData: [],
      tableMaxHeight: document.body.clientHeight - 250,
      total: 0,
      pageSize: 20,
      currentPage: 1,
      orderId: '',
      isEdit: false,
      multipleSelection: [],
      invoiceData: {},
      showInvoice: false,
      paymentId: '',
      tabList: []
    }
  },
  mounted() {
    if (sessionStorage.currentTenantId) {
      this.tenantId = sessionStorage.currentTenantId
    }
    this.loadData()
    this.calcTableHeight()
    this.$root.$on('resize', () => {
      this.calcTableHeight()
    })
  },
  methods: {
    //新增付款时查看订单详情
    showOrderDetail(id) {
      this.orderId = id
      this.showOrderRecord = true
    },
    //获取每个tab数量
    getCount() {
      let params = {
        pageBean: {
          page: 1,
          pageSize: 10,
          total: 0
        }
      }
      if (this.code || this.dateRangeVal) {
        params.querys = []
        if (this.code) {
          params.querys.push({
            group: 'advance',
            value: this.code,
            relation: 'OR',
            operation: 'LIKE',
            property: 'third_order.order_no'
          })
          if (this.tenantId == '-1') {
            params.querys.push({
              group: 'advance',
              value: this.code,
              relation: 'OR',
              operation: 'LIKE',
              property: 'third_order.customer_name'
            })
          }
        }
        if (this.dateRangeVal) {
          params.querys.push({
            group: 'advance',
            operation: 'BETWEEN',
            property: 'third_order.order_time',
            relation: 'AND',
            value: this.dateRangeVal
          })
        }
      }
      this.$http.post('${third}/costcenter/third_order/query_count', params).then((res) => {
        if (res.data) {
          res.data.total =
            parseFloat(res.data.waiting_confirmation) +
            parseFloat(res.data.pending_payment) +
            parseFloat(res.data.payment_received) +
            parseFloat(res.data.payment_confirmed) +
            parseFloat(res.data.waiting_invoicing) +
            parseFloat(res.data.already_invoiced) +
            parseFloat(res.data.already_canceled)
          this.tabList = [
            { label: '全部(' + res.data.total + ')', name: 'total' },
            {
              label: '待确认(' + res.data.waiting_confirmation + ')',
              name: '1'
            },
            { label: '待付款(' + res.data.pending_payment + ')', name: '2' },
            { label: '已付款(' + res.data.payment_received + ')', name: '3' },
            {
              label: '付款已确认(' + res.data.payment_confirmed + ')',
              name: '4'
            },
            {
              label: '待开票(' + res.data.waiting_invoicing + ')',
              name: '5'
            },
            { label: '已开票(' + res.data.already_invoiced + ')', name: '6' },
            { label: '已关闭(' + res.data.already_canceled + ')', name: '0' }
          ]
        }
      })
    },
    //日期格式化
    dateFormatter(row, column) {
      var val = row[column.property]
      if (val) {
        let str = val + ''
        let arr = str.split(' ')
        return arr[0]
      } else {
        return ''
      }
    },
    //千分位格式化
    numberFormatter(row, column) {
      var val = row[column.property]
      if (val == undefined) {
        return ''
      }
      return utils.dataTransform(val.toString())
    },
    // 发票申请
    showInvoiceApply() {
      if (this.multipleSelection && this.multipleSelection.length) {
        const arr = this.multipleSelection.unique('customer_name')
        if (arr.length != 1) this.$message.error('请选择同一客户的订单')
        else {
          const index = this.multipleSelection.find((item) => item.order_status != 4)
          if (index) this.$message.error('所选的记录里，有不可开票的购买订单记录')
          else {
            this.showInvoice = true
            this.invoiceData = {
              customer_name: this.multipleSelection[0].customer_name,
              customer_id: this.multipleSelection[0].tenant_id_,
              tenantId: this.multipleSelection[0].tenant_id_
            }
          }
        }
      } else {
        this.$message.error('暂无可开票的购买订单记录')
      }
    },
    closeInvoice(val) {
      this.showInvoice = false
      this.$refs.ecoTable.clearSelection()
      if (val) {
        this.currentPage = 1
        this.loadData()
      }
    },
    //表头样式
    headerCellStyle({ row, column, rowIndex, columnIndex }) {
      const obj = {
        backgroundColor: '#F3F3F3',
        color: '#333333'
      }
      if (column.type == 'selection') obj.textAlign = 'center'
      return obj
    },
    //列表样式
    cellStyle({ row, column, rowIndex, columnIndex }) {
      let str = column.label
      if (str && str != undefined) {
        if (str.indexOf('金额') > -1 || str.indexOf('收款') > -1) {
          return 'text-align:right'
        } else {
          return 'text-align:left'
        }
      } else {
        return 'text-align:center'
      }
    },
    //tabs切换事件
    handleClick(tab) {
      this.tabsVal = tab.name
      this.currentPage = 1
      this.loadData()
    },
    //table勾选事件
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    //每页数量调整
    handleSizeChange(val) {
      this.pageSize = val
      this.loadData()
    },
    //页数跳转
    handleCurrentChange(val) {
      this.currentPage = val
      this.loadData()
    },
    // 动态计算表格的高度，自适应当前容器
    calcTableHeight(delay) {
      setTimeout(() => {
        if (!this.$refs.tablePanel) {
          return
        }
        const tablePanelHeight = this.$refs.tablePanel.$el.clientHeight
        this.tableMaxHeight = tablePanelHeight - 180
        this.$nextTick(() => {
          this.$refs.ecoTable.doLayout()
        })
      }, delay || 0)
    },
    //table数据加载
    loadData() {
      this.getCount()
      this.tableData = []
      let params = {
        pageBean: {
          page: this.currentPage,
          pageSize: this.pageSize,
          total: 0
        }
      }
      if (this.code || this.dateRangeVal || this.tabsVal != 'total') {
        params.querys = []
        if (this.code) {
          params.querys.push({
            group: 'advance',
            value: this.code,
            relation: 'OR',
            operation: 'LIKE',
            property: 'third_order.order_no'
          })
          if (this.tenantId == '-1') {
            params.querys.push({
              group: 'advance',
              value: this.code,
              relation: 'OR',
              operation: 'LIKE',
              property: 'third_order.customer_name'
            })
          }
        }
        if (this.dateRangeVal) {
          params.querys.push({
            group: 'advance',
            operation: 'BETWEEN',
            property: 'third_order.order_time',
            relation: 'AND',
            value: this.dateRangeVal
          })
        }
        if (this.tabsVal && this.tabsVal != 'total') {
          params.querys.push({
            group: 'advance',
            value: this.tabsVal,
            relation: 'AND',
            operation: 'EQUAL',
            property: 'order_status'
          })
        }
      }
      this.$http.post('${third}/costcenter/third_order/query', params).then((res) => {
        let response = res.data
        this.total = response.total
        this.tableData = response.rows
        this.$refs.ecoTable.doLayout()
        this.calcTableHeight()
      })
    },
    //新增订单关闭
    closeInsert() {
      this.showInsert = false
      this.loadData()
    },
    //申请订单
    insertOrder(id, isEdit) {
      this.orderId = ''
      this.isEdit = false
      if (id) {
        this.orderId = id
      }
      if (isEdit) {
        this.isEdit = isEdit
      }
      this.showInsert = true
    },
    //订单详情
    orderRecord(id) {
      this.orderId = ''
      if (id) {
        this.orderId = id
      }
      this.showOrderRecord = true
    },
    //订单详情关闭
    closeOrderRecord() {
      this.showOrderRecord = false
    },
    //订单确认
    orderConfirm(id, isEdit) {
      this.orderId = ''
      this.isEdit = false
      if (id) {
        this.orderId = id
      }
      if (isEdit) {
        this.isEdit = isEdit
      }
      this.showOrderConfirm = true
    },
    //清单确认关闭
    closeConfirm() {
      this.showOrderConfirm = false
      this.loadData()
    },
    //订单付款
    orderPayment(id, paymentId, isEdit) {
      this.orderId = ''
      this.paymentId = ''
      this.isEdit = false
      if (id) {
        this.orderId = id
      }
      if (paymentId) {
        this.paymentId = paymentId
      }
      if (isEdit) {
        this.isEdit = isEdit
      }
      this.showPayment = true
    },
    //订单付款关闭
    closePayment() {
      this.showPayment = false
      this.loadData()
    },
    //订单付款记录
    paymentRecord(id, status) {
      this.isCancle = false
      this.paymentId = ''
      if (id) {
        this.paymentId = id
      }
      if (status == '3') {
        this.isCancle = true
      }
      this.showPaymentRecord = true
    },
    //订单付款记录关闭
    closePaymentRecord() {
      this.showPaymentRecord = false
    },
    //付款确认
    confirmPayment(id, isEdit) {
      this.paymentId = ''
      this.isEdit = false
      if (id) {
        this.paymentId = id
      }
      if (isEdit) {
        this.isEdit = isEdit
      }
      this.showPaymentConfirm = true
    },
    //付款确认关闭
    closePaymentConfirm() {
      this.showPaymentConfirm = false
      this.loadData()
    },
    //取消付款
    closePay(id, status) {
      this.$confirm('此操作将取消付款, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let params = {
            id: id,
            order_status: status
          }
          this.$http.post('${third}/costcenter/third_order/cancel_pay', params).then((res) => {
            if (res.data.state) {
              this.$message.info('付款单取消成功！')
            }
            this.loadData()
          })
        })
        .catch(() => {})
    },
    //关闭订单
    closeOrder(id, status) {
      this.$confirm('此操作将关闭订单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let params = {
            id: id,
            order_status: status
          }
          this.$http.post('${third}/costcenter/third_order/cancel', params).then((res) => {
            if (res.data.state) {
              this.$message.info('订单关闭成功！')
            }
            this.loadData()
          })
        })
        .catch(() => {})
    },
    //下拉菜单事件
    handleCommand(params) {
      switch (params.command) {
        //订单编辑
        case 'edit':
          this.insertOrder(params.row.id, true)
          break
        //订单确认
        case 'confirm':
          this.orderConfirm(params.row.id, false)
          break
        //订单付款
        case 'pay':
          this.orderPayment(params.row.id, null, false)
          break
        //编辑付款
        case 'editPay':
          this.orderPayment(params.row.id, params.row.payment_id, true)
          break
        //付款确认
        case 'confirmPay':
          this.confirmPayment(params.row.payment_id, false)
          break
        case 'closePay':
          this.closePay(params.row.id, params.row.order_status)
          break
        //关闭订单
        case 'close':
          this.closeOrder(params.row.id, params.row.order_status)
          break
      }
    }
  }
}
</script>

<style scoped>
.oder_management {
  //padding-top: 20px;
  height: calc(100% - 20px);
}
.top_search {
  height: 45px;
  width: 100%;
  display: flex;
  align-items: center;
}
.col_style {
  height: 100%;
  display: flex;
  align-items: center;
}
.col_style p {
  flex-shrink: 0;
}
/deep/.el-input-group__append button.el-button {
  border-color: transparent;
  background-color: #377cff;
  color: white;
  border-top: 0;
  border-bottom: 0;
}
.button_group {
  height: 40px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.page_bean {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
/deep/td:first-child .cell {
  padding-left: 14px !important;
}
</style>
